import { render, staticRenderFns } from "./EquipmentBR.vue?vue&type=template&id=4ebd5fac&scoped=true"
import script from "./EquipmentBR.vue?vue&type=script&lang=js"
export * from "./EquipmentBR.vue?vue&type=script&lang=js"
import style0 from "../EquipmentBR/EquipmentBR.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./EquipmentBR.vue?vue&type=style&index=1&id=4ebd5fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd5fac",
  null
  
)

export default component.exports